export default {
  signal: 'Signal',
  axis: 'Achse',
  color: 'Farbe',
  thickness: 'Dicke',
  stepped: 'Gestuft',
  selectAxisPlaceholder: 'Achse auswählen oder erstellen',
  auto: 'Auto',
  addSignal: 'Signale hinzufügen',
  selectSignals: 'Signale auswählen',
};
